import React, { useEffect, useState } from "react";
import { Calculator, TrendingDown, TrendingUp } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import ShareButton from "../../components/shareButton/share-button";

export default function Home() {
  const [liters, setLiters] = useState("50");
  const [priceNL, setPriceNL] = useState("1.85");
  const [priceDE, setPriceDE] = useState("1.65");
  const [distance, setDistance] = useState("20");
  const [consumption, setConsumption] = useState("6.5");

  // Parse values, default to 0 if empty
  const litersNum = parseFloat(liters) || 0;
  const priceNLNum = parseFloat(priceNL) || 0;
  const priceDENum = parseFloat(priceDE) || 0;
  const distanceNum = parseFloat(distance) || 0;
  const consumptionNum = parseFloat(consumption) || 0;

  // Berekeningen
  const costNL = litersNum * priceNLNum;
  const costDE = litersNum * priceDENum;
  const fuelForTrip = distanceNum * 2 * (consumptionNum / 100);
  const tripCost = fuelForTrip * priceDENum;
  const totalCostDE = costDE + tripCost;
  const savings = costNL - totalCostDE;
  const breakEvenDistance =
    consumptionNum > 0 && priceDENum > 0
      ? (litersNum * (priceNLNum - priceDENum)) /
        (2 * (consumptionNum / 100) * priceDENum)
      : 0;

  const isWorthIt = savings > 0;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const liters = params.get("liters");
    const priceNl = params.get("priceNl");
    const priceDe = params.get("priceDe");
    const distance = params.get("distance");
    const consumption = params.get("consumption");

    if (liters && priceNl && priceDe && distance && consumption) {
      setLiters(liters);
      setPriceNL(priceNl);
      setPriceDE(priceDe);
      setDistance(distance);
      setConsumption(consumption);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 p-4">
      <div className="max-w-6xl mx-auto">
        {/* Top Banner Ad - 728x90 */}
        {/* <div className="bg-white rounded-lg shadow-md p-4 mb-6 flex items-center justify-center">
          <div className="adsense-container" style={{minHeight: '90px', minWidth: '728px'}}> */}
        {/* Placeholder voor demo */}
        {/* <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded flex items-center justify-center text-gray-400 text-sm" style={{width: '728px', height: '90px'}}>
              AdSense Banner 728x90
            </div>
          </div>
        </div> */}

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8">
              <div className="flex items-center justify-between gap-3 mb-6">
                <div className="flex items-center gap-3">
                  <Calculator className="w-8 h-8 text-blue-600" />
                  <h1 className="text-3xl font-bold text-gray-800">
                    Tankvergelijk.nl: NL vs DE
                  </h1>
                </div>
                <ShareButton
                  currentUrl={window.location.origin}
                  liters={litersNum}
                  priceNl={priceNLNum}
                  priceDe={priceDENum}
                  distance={distanceNum}
                  consumption={consumptionNum}
                  savedAmount={savings}
                />
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                {/* Input sectie */}
                <div className="space-y-4">
                  <h2 className="text-xl font-semibold text-gray-700 mb-4">
                    Invoer
                  </h2>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Aantal liters tanken
                    </label>
                    <input
                      type="number"
                      value={liters}
                      onChange={(e) => setLiters(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      step="1"
                      min="0"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Prijs Nederland (€/liter)
                    </label>
                    <input
                      type="number"
                      value={priceNL}
                      onChange={(e) => setPriceNL(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      step="0.01"
                      min="0"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Prijs Duitsland (€/liter)
                    </label>
                    <input
                      type="number"
                      value={priceDE}
                      onChange={(e) => setPriceDE(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      step="0.01"
                      min="0"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Afstand naar tankstation (km, enkele reis)
                    </label>
                    <input
                      type="number"
                      value={distance}
                      onChange={(e) => setDistance(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      step="1"
                      min="0"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Verbruik (liter/100km)
                    </label>
                    <input
                      type="number"
                      value={consumption}
                      onChange={(e) => setConsumption(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      step="0.1"
                      min="0"
                    />
                  </div>
                </div>

                {/* Resultaten sectie */}
                <div className="space-y-4">
                  <h2 className="text-xl font-semibold text-gray-700 mb-4">
                    Resultaten
                  </h2>

                  <div className="bg-blue-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-600 mb-1">
                      Kosten tanken in Nederland
                    </p>
                    <p className="text-2xl font-bold text-blue-600">
                      € {costNL.toFixed(2)}
                    </p>
                  </div>

                  <div className="bg-green-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-600 mb-1">
                      Kosten tanken in Duitsland
                    </p>
                    <p className="text-2xl font-bold text-green-600">
                      € {costDE.toFixed(2)}
                    </p>
                  </div>

                  <div className="bg-orange-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-600 mb-1">
                      Brandstof voor rit (retour)
                    </p>
                    <p className="text-lg font-semibold text-orange-600">
                      {fuelForTrip.toFixed(2)} L = € {tripCost.toFixed(2)}
                    </p>
                  </div>

                  <div className="bg-purple-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-600 mb-1">
                      Totale kosten Duitsland
                    </p>
                    <p className="text-2xl font-bold text-purple-600">
                      € {totalCostDE.toFixed(2)}
                    </p>
                  </div>

                  <div
                    className={`p-5 rounded-lg ${
                      isWorthIt
                        ? "bg-green-100 border-2 border-green-400"
                        : "bg-red-100 border-2 border-red-400"
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      {isWorthIt ? (
                        <TrendingDown className="w-6 h-6 text-green-700" />
                      ) : (
                        <TrendingUp className="w-6 h-6 text-red-700" />
                      )}
                      <p className="text-sm font-medium text-gray-700">
                        {isWorthIt ? "Besparing" : "Duurder"}
                      </p>
                    </div>
                    <p
                      className={`text-3xl font-bold ${
                        isWorthIt ? "text-green-700" : "text-red-700"
                      }`}
                    >
                      {isWorthIt ? "€ " : "€ -"}
                      {Math.abs(savings).toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>

              {/* In-content Ad - 336x280 */}
              {/* <div className="bg-gray-50 rounded-lg p-4 mb-6 flex items-center justify-center">
                <div className="adsense-container" style={{minHeight: '280px', minWidth: '336px'}}> */}
              {/* Placeholder voor demo */}
              {/* <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded flex items-center justify-center text-gray-400 text-sm" style={{width: '336px', height: '280px'}}>
                    AdSense Medium Rectangle 336x280
                  </div>
                </div>
              </div> */}

              {/* Break-even informatie */}
              <div className="bg-gray-50 p-6 rounded-lg border-2 border-gray-200">
                <h3 className="text-lg font-semibold text-gray-700 mb-3">
                  Break-even analyse
                </h3>
                <p className="text-gray-600 mb-2">
                  Met deze parameters is tanken in Duitsland voordelig tot een
                  afstand van:
                </p>
                <p className="text-2xl font-bold text-indigo-600">
                  {breakEvenDistance > 0
                    ? `${breakEvenDistance.toFixed(1)} km`
                    : "Nooit voordelig (DE is duurder)"}
                </p>
                {distanceNum > breakEvenDistance && breakEvenDistance > 0 && (
                  <p className="text-sm text-red-600 mt-2">
                    ⚠️ Je huidige afstand ({distance} km) is verder dan de
                    break-even afstand
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Banner Ad - 728x90 */}
        {/* <div className="bg-white rounded-lg shadow-md p-4 mt-6 flex items-center justify-center">
          <div className="adsense-container" style={{minHeight: '90px', minWidth: '728px'}}> */}
        {/* Placeholder voor demo */}
        {/* <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded flex items-center justify-center text-gray-400 text-sm" style={{width: '728px', height: '90px'}}>
              AdSense Banner 728x90
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
